/**
 * SoKeto cookie banner — Shopify Customer Privacy API + localStorage persistence.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'soketo_cookie_consent_v1';
  var BANNER_ID = 'soketo-cookie-banner';

  function getBannerEl() {
    return document.getElementById(BANNER_ID);
  }

  function readStoredConsent() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return null;
      var o = JSON.parse(raw);
      if (o && (o.accept === true || o.accept === false)) return o;
    } catch (e) {}
    return null;
  }

  function writeStoredConsent(accept) {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ accept: !!accept, ts: Date.now() })
      );
    } catch (e) {}
  }

  function showBanner() {
    var el = getBannerEl();
    if (!el) return;
    el.hidden = false;
    el.removeAttribute('hidden');
    el.setAttribute('aria-hidden', 'false');
  }

  function hideBanner() {
    var el = getBannerEl();
    if (!el) return;
    el.hidden = true;
    el.setAttribute('hidden', '');
    el.setAttribute('aria-hidden', 'true');
  }

  function applyShopifyConsent(accept, api) {
    if (!api || typeof api.setTrackingConsent !== 'function') return;
    var marketing = !!accept;
    var analytics = !!accept;
    var preferences = !!accept;
    api.setTrackingConsent(
      {
        marketing: marketing,
        analytics: analytics,
        preferences: preferences,
      },
      function () {}
    );
  }

  function wireButtons(api) {
    var banner = getBannerEl();
    if (!banner) return;

    banner.addEventListener('click', function (e) {
      var btn = e.target && e.target.closest('[data-soketo-cookie]');
      if (!btn || !banner.contains(btn)) return;
      var action = btn.getAttribute('data-soketo-cookie');
      var accept = action === 'accept';
      writeStoredConsent(accept);
      applyShopifyConsent(accept, api);
      hideBanner();
    });
  }

  function consentAlreadyRecorded(c) {
    if (!c || typeof c !== 'object') return false;
    return (
      c.marketing === true ||
      c.marketing === false ||
      c.analytics === true ||
      c.analytics === false
    );
  }

  function initWithApi(api) {
    wireButtons(api);

    var stored = readStoredConsent();
    if (stored !== null) {
      applyShopifyConsent(stored.accept, api);
      hideBanner();
      return;
    }

    if (typeof api.currentVisitorConsent === 'function') {
      var c = api.currentVisitorConsent();
      if (consentAlreadyRecorded(c)) {
        hideBanner();
        return;
      }
    }

    if (typeof api.shouldShowBanner === 'function' && api.shouldShowBanner()) {
      showBanner();
      return;
    }

    hideBanner();
  }

  function onLoadFeatures(error) {
    if (error) {
      console.warn('[soketo-cookie-banner] loadFeatures error', error);
      var stored = readStoredConsent();
      if (stored !== null) {
        hideBanner();
      } else {
        showBanner();
        wireButtons(null);
      }
      return;
    }

    var ShopifyPrivacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!ShopifyPrivacy) {
      var s = readStoredConsent();
      if (s !== null) hideBanner();
      else {
        showBanner();
        wireButtons(null);
      }
      return;
    }

    initWithApi(ShopifyPrivacy);

    document.addEventListener('visitorConsentCollected', function () {
      hideBanner();
      try {
        var CP = window.Shopify && window.Shopify.customerPrivacy;
        var c = CP && CP.currentVisitorConsent && CP.currentVisitorConsent();
        if (consentAlreadyRecorded(c)) {
          var acc = c.marketing === true || c.analytics === true;
          writeStoredConsent(acc);
        }
      } catch (e) {}
    });
  }

  function boot() {
    if (!getBannerEl()) return;

    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.1' }],
        onLoadFeatures
      );
    } else {
      onLoadFeatures(new Error('Shopify.loadFeatures unavailable'));
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
